import { Button } from "antd";
import styled from "styled-components";

export const StyledButton = styled(Button)<{ $action: "delete" | "add" }>`
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    font-size: 20px;

    color: ${({ theme, $action }) => {
        let color = theme.primaryTypographyColor;

        switch ($action) {
            case "add":
                color = theme.successTypographyColor;
                break;
            case "delete":
                color = theme.dangerTypographyColor;
                break;
            default:
                break;
        }

        return color;
    }};
`;

export const StyledFieldContainer = styled.div`
    width: 100px;
`;
